import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import ProgrammationForm from '../../components/programmation/ProgrammationForm';
import { CircularProgress } from '@mui/material';

const NewProgrammation = () => {
  const { user, status } = useAuthContext();
  const currentUser = user;
  const isLoading = status === 'loading';
  const navigate = useNavigate();

  // Rediriger vers la page de connexion si l'utilisateur n'est pas connecté
  useEffect(() => {
    if (!isLoading && !currentUser) {
      navigate('/login', { state: { from: '/programmation/create' } });
    }
  }, [currentUser, isLoading, navigate]);

  if (isLoading || !currentUser) {
    return (
      <div className="flex justify-center items-center h-64">
        <CircularProgress size="lg" />
      </div>
    );
  }

  return (
    <div className="w-full">
      <ProgrammationForm />
    </div>
  );
};

export default NewProgrammation;
